<template>
    <div class="px-2">
        <v-toolbar flat>
            <v-toolbar-title><b>User Location And Feedback</b></v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>

        <div class="custom-bg_locfeed">
        <v-row class="pa-2" no-gutters>
            <v-spacer></v-spacer>
                <div class="mr-3"> Search: </div>  
                    <v-col cols="12" sm="6" md="2">
                        <v-text-field
                            prepend="search"
                            type="text"
                            dense
                            v-model="search"
                            single-line
                            hide-details
                            outlined
                            no-gutters
                            height="5"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-data-table
                    dense
                    fixed-header
                    :headers="headers" 
                    bold
                    :items="locationItems"
                    :items-per-page="10"
                    sort-by="['serialNum', 'locationDeviceId','locationLatitude', 'locationLongitude']"
                    :search="search"
                >
            
                    <template v-slot:item.serialNum="{item}">
                        {{locationItems.indexOf(item)+1}}
                    </template>   
                    <template v-slot:item.locationDateTime="{item}">
                        {{item.locationDateTime}}
                    </template>  
                    <template v-slot:item.viewFeedback="{item}"> 
                        <v-icon
                            class="mr-2"
                            color="blue darken-3"
                            @click="openFeedbackDialog(item)"
                        >mdi-eye
                        </v-icon>
                    </template>
                </v-data-table>

                <v-dialog
                    v-model="dialog"
                    max-width="500px"
                    max-height="200px"
                >
                    <v-card>
                        <v-card-title>
                            <span class="headline" style="size=6px">
                                Feedback for <br> <b>{{feedbackDeviceId}}</b>
                            </span>
                        </v-card-title> 
                        <v-data-table
                            dense
                            fixed-header
                            :headers="headersFeedback" 
                            bold
                            :items="feedbackItems"
                            :items-per-page="10"
                            sort-by="['feedbackRating','feedbackText', 'feedbackDateTime']"
                            :search="search"
                        >
                            <template v-slot:item.feedbackDateTime="{item}">
                               {{item.feedbackDateTime}} 
                            </template> 
                        </v-data-table>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="dialog=false"
                          >
                            Close
                        </v-btn>
                    </v-card-actions> 
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import url1 from '../../../config.js';

export default {
     beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (!vm.$store.state.auth.adminUser._id)
                  {
                     vm.$router.push("/");
                  }  
            }, 0);
        });
    },
    name: "LocationFeedback",
    data() {
        return {
            search:'',
            disabled:false,
            headers: [
                { text: "S.No", value: "serialNum" },
                { text: "Date/Time", value: "locationDateTime" },
                { text: "Device Id", value: "locationDeviceId" },
                { text: "Latitude", value: "locationLatitude" },
                { text: "Longitude", value: "locationLongitude" },
                { text: "View Feedback", value: "viewFeedback" }
            ],

            headersFeedback: [
                { text: "Rating", value: "feedbackRating" },
                { text: "Text", value: "feedbackText" },
                {text: 'Date/Time', value:"feedbackDateTime"}
            ],

            //locationFeedbackItems: [],
            dialog:false,
            locationItems: [],
            feedbackDeviceId:'',
            feedbackItems:[],
            errorMessage: "",
            url:url1.url
            };
    },

    methods: {

        getLocations() {
            //console.log('url', this.url);
            axios.get(`${this.url}/api/location/getalllocations`, {headers:{'x-auth-token':this.auth.token}}).then(
                res=>{
                    //console.log('locations', res);
                    this.locationItems=res.data;
                    }
            ).catch(err => console.error(err.response.data));
        },

        getFeedback(feedbackDeviceId)
        {
            this.feedbackDeviceId=feedbackDeviceId;
            axios.get(`${this.url}/api/feedback/getfeedbackofspecificdevice/${feedbackDeviceId}`, {headers:{'x-auth-token':this.auth.token}}).
            then(res=>{
                //console.log('feedbacks', res.data);
                this.feedbackItems=res.data;
            }).catch(err => console.error(err.response.data));
        },

        openFeedbackDialog(item){
            this.dialog=true;
            this.getFeedback(item.locationDeviceId);
        },

        // close(){
        //     this.dialog=false;
        // }
    },
    computed: {
        auth() {
            return this.$store.state.auth;
        },    
    },

    // watch: {
    //   dialog (val) {
    //     val || this.close()
    //   },
    // },

    mounted() {
        this.getLocations();
    }
 }

</script>

<style scoped>
.theme--light.v-card {
    background: white;
    border: 0;
}
.custom-bg_locfeed {
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-top: 3px solid #d2d6de;
}
</style>
